import React from 'react';
import bannerBg from '../assets/img/page-banner.jpg';
import AboutFeatured from '../components/AboutFeatured';
import Approch from '../components/Approch';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import PageBanner from '../components/PageBanner';
import SkillSet from '../components/SkillSet';
import Sponsors from '../components/Sponsors';
import Timeline from '../components/Timeline';
import Process2 from '../components/Process2';
import Cta from '../components/Cta';

function About() {
    return (
        <>
            <Header1 />
            <PageBanner bannerBg={bannerBg} currentPage="About Us" heading="About Us" />
            <Process2 />
            <AboutFeatured />
            <Approch />
            <SkillSet />
            {/* <Sponsors />
            <Timeline /> */}
            <Cta/>
            <Footer1 />
        </>
    );
}

export default About;
